import React, { memo } from "react";
// import ReactDOM from "react-dom";
// import { TransitionGroup, CSSTransition } from "react-transition-group";
// import { styled, $white } from "@acko-tech/building-blocks.ui.common";
import ModalHeader from "./header";

import removeModalBackgroundScroll from "utils/removeModalBackgroundScroll";

// const duration = 500;

// const ModalWrapper = styled.div`
//   background: ${$white};
//   z-index: 20;
//   border-radius: 16px 16px 0 0;
//   width: 100%;
//   position: fixed;
//   ${(props: { variant?: string }): string =>
//     props.variant === "large" ? "top: 6.5%" : ""};
//   bottom: 0;
//   left: 0;
//   padding: 30px 20px;
//   overflow: scroll;
//   &.modal-transition-enter {
//     transform: translateY(100%);
//   }
//   &.modal-transition-enter-active {
//     transition: transform ${duration}ms;
//     transform: translateY(0);
//   }
//   &.modal-transition-exit {
//     transform: translateY(0);
//   }
//   &.modal-transition-exit-active {
//     transition: transform ${duration}ms;
//     transform: translateY(100%);
//   }
//   box-sizing: border-box;
//   ${props => (props.height ? `height: ${props.height}` : "")};
//   ${props => (props.hideTopPadding ? `padding-top: 0` : "")};
//   ${props => (props.fullScreen ? `height: 100%; border-radius: 0;` : "")}
//   ${props => (props.padding ? `padding: ${props.padding}` : "")};
//   ${props => props.styles}
// `;

// const Overlay = styled.div`
//   background-color: rgba(46, 46, 51, 0.66);
//   height: 100%;
//   position: fixed;
//   width: 100%;
//   top: 0;
//   left: 0;
//   z-index: 19;
// `;

// const ModalBody = styled.div`
//   margin-top: 25px;
//   ${props => props.styles}
// `;

// here
function Modal({
  children,
  header,
  show,
  onHide,
  // variant,
  hideTopPadding,
  align,
  hideCloseButton,
  // height,
  // fullScreen,
  // padding,
  closeButtonStyles,
  bodyWrapperStyles,
  headerStyles,
  styles
}: React.PropsWithChildren<ModalProps>): JSX.Element {
  removeModalBackgroundScroll({ showModal: show });

  return (
    <>
      {show && (
        <div
          className=" bg-opacity-60 h-full w-full fixed top-0 left-0 z-20"
          onClick={onHide}
          style={{ background: "rgba(46, 46, 51, 0.66)" }}
        />
      )}
      {show && (
        <div
          style={
            styles
              ? {
                  background: "white",
                  maxHeight: "90%",
                  borderRadius: "24px 24px 0 0",
                  ...styles
                }
              : {
                  background: "white",
                  borderRadius: "24px 24px 0 0",
                  maxHeight: "90%"
                }
          }
          className="bg-white fixed bottom-0 left-0 w-full border rounded-t-lg z-30 py-7 px-5 overflow-scroll"
        >
          <ModalHeader
            closeButton={!hideCloseButton}
            header={header}
            onClick={onHide}
            align={align}
            hideTopPadding={hideTopPadding}
            closeButtonStyles={closeButtonStyles}
            headerStyles={headerStyles}
          />
          <div className="mt-5" style={bodyWrapperStyles}>
            {children}
          </div>
        </div>
      )}
    </>
  );
}

interface ModalProps {
  header?: JSX.Element | undefined;
  show?: Boolean | string;
  onHide(): void;
  variant?: string;
  align?: string;
  hideCloseButton?: boolean;
  height?: string;
  hideTopPadding?: boolean;
  fullScreen?: boolean;
  padding?: string;
  closeButtonStyles?: any;
  bodyWrapperStyles?: any;
  headerStyles?: any;
  styles?: any;
}

export default memo(Modal);
